import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';

const useStyles = makeStyles((theme) =>
  createStyles({
    claimItem: {
      fontSize: 13,
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 5,
      [theme.breakpoints.down('sm')]: {
        fontSize: 11,
      },
    },
    wrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      textAlign: 'right',
    },
  }),
);

const HeaderText: React.FC<any> = ({ text }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div className={classes.claimItem}>{text}</div>
    </div>
  );
};

export default HeaderText;
